<script lang="ts" setup>
    import { InsuranceType, PayerMixReportDateType } from '../../Enums/ChoiceEnums';
    import TitledRow from '../../components/TitledRow.vue';
    import DatePickerNoTZ from '../../components/DatePickerNoTZ.vue';
    import { PayerMixDateTypes, PayerMixInsuranceTypes } from './PayerMixUtils'
    import BooleanButtonGroup from '../../components/BooleanButtonGroup.vue'
    import { NoTzDate } from '../../lib/DateUtils';

    export interface IPayerMixQueryData {
        dateType?: PayerMixReportDateType,
        startDate?: NoTzDate,
        endDate?: NoTzDate,
        includeProcedureCode: boolean,
        includeAllowedAmount: boolean,
        insuranceType: InsuranceType
    }

    const props = defineProps<{values: IPayerMixQueryData}>();

    const emit = defineEmits(["update:values"]);

    function OnUpdate() {
        emit('update:values', props.values);
    }
</script>

<template>
    <TitledRow title="Date Type" content-class="col-sm-9">
        <select class="form-select" v-model="props.values.dateType" @change="OnUpdate">
            <option v-for="item in PayerMixDateTypes" :value="item.dateType">
                {{item.name}}
            </option>
        </select>
    </TitledRow>

    <TitledRow title="Start Date" content-class="col-sm-9">
        <DatePickerNoTZ v-model:value="props.values.startDate" :clearable="false" />
    </TitledRow>

    <TitledRow title="End Date" content-class="col-sm-9">
        <DatePickerNoTZ v-model:value="props.values.endDate" :clearable="false" />
    </TitledRow>

    <TitledRow title="Insurance" content-class="col-sm-9">
        <select class="form-select" v-model="props.values.insuranceType" @change="OnUpdate">
            <option :value="item.insuranceType" v-for="item in PayerMixInsuranceTypes">
                {{item.name}}
            </option>
        </select>
    </TitledRow>

    <TitledRow title="Procedure Codes">
        <BooleanButtonGroup v-model:value="props.values.includeProcedureCode" trueText="Include" falseText="Not Included" />
    </TitledRow>

    <TitledRow title="Allowed Amount">
        <BooleanButtonGroup v-model:value="props.values.includeAllowedAmount" trueText="Include" falseText="Not Included" />
    </TitledRow>    

    <TitledRow>
        <slot name="bottomRow">
        </slot>
    </TitledRow>
</template>